import { ConfirmationModalOptions } from './../../models/modal.model';
import { Component, OnInit, Output, Input, EventEmitter, AfterViewInit, OnChanges, AfterContentInit, AfterViewChecked } from '@angular/core';
import { ConstantesService } from '../../services/constantes.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from '../../services/url.service';
import { GlobalService } from '../../global.service';
import { AlertService } from '../../services/alert.service';
import { UrlControl } from '../../models/generic.model';
import { DominiosService } from '../../services/dominios.service';
import { DomSanitizer } from '@angular/platform-browser';
import { VariablesZonaCompartida } from '../../services/VariablesZonaCompartida';

declare var $: any;
@Component({
  selector: 'app-tarjeta',
  templateUrl: './tarjeta.component.html',
  styleUrls: ['./tarjeta.component.scss']
})
export class TarjetaComponent implements OnInit, OnChanges {

  public banderaRolVigilante: string;
  public banderaRolPreautorizador: string;
  public estadoAgendaAgendada: string;
  public estadoAgendaActCon: string;
  public estadoAgendaActSin: string;
  public urlFtp: string;

  @Output() detalle: EventEmitter<any>;
  @Output() buscaAgendas: EventEmitter<any>;
  @Output() refrescar: EventEmitter<any>;
  @Input() objeto: any[] = [];
  @Input() rol: string;
  paginas: number[] = [];
  inicio: number;
  fin: number;
  @Input() filtroNombre: string;
  public modalDeleteMessage: ConfirmationModalOptions;

  public modalPrintMessage: ConfirmationModalOptions;
  public modalReSendMessage: ConfirmationModalOptions;
  public campos: any;
  public htmlSticker: string;
  public datoSeleccion: any;
  public objetoFichaVisitante: any;
  public p: any;

  constructor(
      private router: Router, private spinner: NgxSpinnerService
    , private urlService: UrlService, private global: GlobalService
    , private alertService: AlertService, private sanitizer: DomSanitizer) {
    this.detalle = new EventEmitter();
    this.buscaAgendas = new EventEmitter();
    this.refrescar = new EventEmitter();
    this.inicio = 0;
    this.fin = 6;

    // damunoz:
    // creación y asignación de variables para poder usar constantes en codigo html
    this.banderaRolVigilante = ConstantesService.BANDERA_ROL_VIGILANTE;
    this.banderaRolPreautorizador = ConstantesService.BANDERA_ROL_PREAUTORIZADOR;

    this.estadoAgendaAgendada = DominiosService.ESTADO_AGENDA_AGENDADA;
    this.estadoAgendaActCon = DominiosService.ESTADO_AGENDA_ACT_CON;
    this.estadoAgendaActSin = DominiosService.ESTADO_AGENDA_ACT_SIN;

    // fromero:
    // en el constructor se debe crear el objeto de opciones del modal que se estan inyectando en el html,
    // cuando son formularios
    this.modalDeleteMessage = new
      ConfirmationModalOptions('Confirmación', '¿Está Seguro de borrar del grupo?', 'Si', 'No', 'fas fa-trash'
        , false, false, 'Retirar del grupo', false, 'btn-danger col-lg-5 col-md-11 col-sm-11 col-xs-11');
  }

  ngOnInit() {
    this.inicializarModal();
    this.cargarUrlFoto();
    // if (this.objeto) {
    //   this.objeto.forEach(obj => {
    //     obj.urlFoto = this.obtenerUrlFoto(obj.urlFotoVisitante);
    //   });
    // }
  }

  ngOnChanges(): void {
    if (this.objeto) {
      this.objeto.forEach(obj => {
        obj.urlFoto = this.obtenerUrlFoto(obj.urlFotoVisitante);
      });
    }
   }
  getConfirmationModalResponse(event, objeto) {
    this.detalle.emit({ respuesta: event, objeto });
  }

  // fromero
  // Metodo de redirección a Ingreso, Salida o Editar del CU_005 ConsultaVisitantes
  // 21/05/2019
  redireccionConsultaVisita(obj: any, tipo: string) {
    this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA] = obj;
    switch (tipo) {
      case 'ImprimirVigilante':
      case 'CompletarVigilanteIngreso':
      case 'RetomarVisita':
        this.router.navigate(['main/registro-entrada-visitante']);
        break;
      case 'CompletarVigilanteSalida':
      case 'SalidaVigilante':
        this.router.navigate(['main/registro-salida-visitante']);
        break;
      case 'EditarPreautorizador':
      case 'CrearPreautorizador':
        this.router.navigate(['main/registrar-nueva-visita']);
        break;
    }

    this.detalle.emit({ objeto: obj, idEvent: 'detalleObj' });
  }

  // fromero
  // metodo para disparar trigger de busqueda de más agendas
  // 21/05/2019

  buscarAgendas(obj) {
    this.buscaAgendas.emit({ repuesta: true, objeto: JSON.stringify(obj) });
  }

  /**
   * Método que reemplaza los valores de la plantilla por la información obtenida
   * @author jnmartinez
   * 24/07/2019
   */
  reemplazarCampos() {
    const nombreAtributos = Object.getOwnPropertyNames(this.campos);
    for (const nombre of nombreAtributos) {
      this.htmlSticker = this.htmlSticker.replace('[' + nombre + ']', this.campos[nombre]);
    }
  }

  inicializarModal() {
    this.modalPrintMessage = new
      ConfirmationModalOptions('Confirmación', '¿Está seguro de registrar entrada y de imprimir sticker?'
        , 'Si', 'No', 'fas fa-print', false, false, 'Imprimir Sticker', undefined
        , 'btn-secondary btn-sticker col-lg-5 col-md-11 col-sm-11 col-xs-11');
    this.modalReSendMessage = new
      ConfirmationModalOptions('Exito', 'Se registró entrada exitosamente', 'Reimprimir', 'Cerrar', ''
        , false, false, 'Reimprimir', undefined, 'btn-auxiliar col-lg-5 col-md-11 col-sm-11 col-xs-11');
  }

  /**
   * Carga el visitante al que se imprimirá el sticker
   * @param obj datos del visitante seleccionado
   * @author jnmartinez
   */
  cargarDatosSticker(obj) {
    this.datoSeleccion = obj;
    this.getInformacionVisitante();
  }

  // fromero
  // método de consulta de información de visitante Básica y agendas del día
  // 13/05/2019
  getInformacionVisitante() {
    this.spinner.show();
    let fechaConsulta;
    // se construye la fecha
    if (this.datoSeleccion && this.datoSeleccion.agendaVisita) {
      fechaConsulta = this.datoSeleccion.agendaVisita.split(' ')[0];
      const fecha = fechaConsulta.split('/');
      fechaConsulta = fecha[0] + '/' + fecha[1] + '/' + fecha[2];
    }

    const serviceProvider = 'ObetenerInformacionAgendasVisitante';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['tipoDocumento', this.datoSeleccion.tipoIdVisitante]);
    queryParams.push(['numeroDocumento', this.datoSeleccion.numeroIdVisitante]);
    queryParams.push(['fechaConsulta', fechaConsulta]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url).subscribe(
      data => {
        this.objetoFichaVisitante = data[0];
        this.objetoFichaVisitante.numeroDocumento = this.datoSeleccion.numeroIdVisitante;
        this.objetoFichaVisitante.tipoVisitante = this.datoSeleccion.tipoVisitante;
        this.objetoFichaVisitante.codigoTipoDocumento = this.datoSeleccion.tipoIdVisitante;
        $('.btn-sticker').click();
        this.spinner.hide();
      }, err => {
        this.catchException(err);
      }
    );
  }

  getConfirmationModal(event) {
    if (event[0] === true) {
      this.guardarIngresoVisitante();
    }
  }

  /**
   * Método que realiza el registro del ingreso
   * @author jnmartinez
   */
  public guardarIngresoVisitante() {
    const serviceProvider = 'RegistrarIngresoVisitante';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    if (!this.objetoFichaVisitante) { return; }
    this.spinner.show();

    this.global.postGenerico(url, this.objetoFichaVisitante).subscribe(
      data => {
        this.campos = data;
        this.imprimir();
        $('.btn-auxiliar').click();
        this.spinner.hide();
      }, err => {
        this.catchException(err);
      }
    );
  }

  /**
   * Método que recibe la confirmación de la reimpresión del sticker
   * @author jnmartinez
   * @param event evento para confirmar la ejecución de la acción
   */
  getConfirmationModalAux(event) {
    if (event[0] === true) {
      this.imprimir();
      setTimeout(() => {
        this.refrescar.emit(true);
      }, 100);
    } else {
      this.refrescar.emit(true);
    }
  }

  /**
   * Método que realiza la impresión de la plantilla
   * @author jnmartinez
   * 24/07/2019
   */
  imprimir() {
    this.htmlSticker = ConstantesService.HTML_STICKER;
    this.reemplazarCampos();
    // tslint:disable: no-string-literal
    window.frames['print_frame'].document.body.innerHTML = this.htmlSticker;
    window.frames['print_frame'].window.focus();
    setTimeout(() => {
      window.frames['print_frame'].window.print();
      window.frames['print_frame'].document.body.innerHTML = '';
    }, 100);
  }

  catchException(error) {
    this.spinner.hide();
    if (error && error.error) {
      this.alertService.generateAlertError(error.error.message, 'Error');
    } else {
      this.alertService.generateAlertError('Se presento un error imprimiendo el sticker', 'Error');
    }
  }

  public cargarUrlFoto() {

    this.urlFtp = sessionStorage.getItem(ConstantesService.FTP_SESSSION);
  }

  public obtenerUrlFoto(url: string): any {
    if (this.urlFtp && this.urlFtp !== '' && url) {
      const valor = Math.random();
      return this.sanitizer.bypassSecurityTrustUrl(this.urlFtp + url + `?random=${valor}`);
    } else {
      return 'https://alfatecsistemas.es/wp-content/uploads/2014/12/Personal-Brand.jpg';
    }
  }
}
